import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import ThemedButton from 'common/ThemedButton';
let defer = () => { };
export const confirmationDialog = (...args) => {
    defer(...args);
};
export const ConfirmationDialogContainer = ({ children }) => {
    const { t } = useTranslation(['common', 'orders', 'specification']);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [customTitle, setCustomTitle] = useState('');
    const [onConfirm, setOnConfirm] = useState(() => () => { });
    const [onCancel, setOnCancel] = useState(() => () => { });
    defer = (message_, onConfirm_, customTitle_, onCancel_) => {
        setMessage(message_);
        setCustomTitle(customTitle_ !== null && customTitle_ !== void 0 ? customTitle_ : 'confirmation_dialog_title');
        setOnConfirm(onConfirm_);
        if (onCancel_) {
            setOnCancel(onCancel_);
        }
        setOpen(false);
        setTimeout(() => {
            setOpen(true);
        });
    };
    const handleConfirm = () => {
        setOpen(false);
        onConfirm();
    };
    const handleCancel = () => {
        setOpen(false);
        onCancel();
    };
    return (React.createElement("div", null,
        children,
        React.createElement(Dialog, { open: open, onClose: handleCancel, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", fullWidth: true, maxWidth: "sm" },
            React.createElement(DialogTitle, { id: "alert-dialog-title" }, t(customTitle)),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: "alert-dialog-description" }, message)),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: handleCancel, autoFocus: true }, t('button_cancel')),
                React.createElement(ThemedButton, { onClick: handleConfirm }, t('button_confirm'))))));
};
